module.exports = __webpack_public_path__ + "img/new_spotd10.cdad89d9.gif";